<section class="bdm-page-container" [class.bdm-page-container--empty]="!hasNews">
  <div class="bdm-news-header">
    <p class="rs-eyebrow rs-eyebrow--center">Aktuelles</p>
    <h2 class="title">Was gibt's Neues?</h2>
    <p class="context">Laufend aktualisiert – die wichtigsten Neuigkeiten aus der Metzgerei.</p>
  </div>
  <app-bdm-news-overview (loaded)="onNewsLoaded($event)"></app-bdm-news-overview>
</section>
